export default function whatsappLink(facture) {
    const numero = this.formatNumero(facture.article?.numero_whatsapp)

    if (!numero) {
        return '#'
    }

    const normalizedDate = String(facture.date_delivery || '').trim()
    const hasTimezone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(normalizedDate)
    const date = new Date(
        hasTimezone
            ? normalizedDate
            : normalizedDate.replace(' ', 'T') + '+01:00'
    )
    const dateIsValid = !Number.isNaN(date.getTime())

    const dateExpiration = dateIsValid ? `${date.toLocaleDateString(this.langue, {
        timeZone: 'Africa/Douala',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })} à ${date.toLocaleTimeString(this.langue, {
        timeZone: 'Africa/Douala',
        hour: '2-digit',
        minute: '2-digit'
    })}` : 'la date indiquee sur la commande'

    const vendeurName = facture.vendeur?.name || 'cher vendeur'
    const articleName = [facture.article?.marque, facture.article?.nom].filter(Boolean).join(' ') || 'votre article'
    const matricule = facture.matricule || ''
    const relaiName = [facture.relai?.quartier, facture.relai?.ville].filter(Boolean).join(', ') || 'le point relais indique sur la commande'

    const message = `Bonjour ${vendeurName},

ALERTE : le délai pour livrer votre article au point relais expire le ${dateExpiration}.

*Article :* ${articleName}
*Commande :* N°${matricule}
*Point relais :* ${relaiName}

Merci de déposer l'article au point relais avant cette date et de vous munir d'une *pièce d'identité*.

*En cas d'empêchement*, une autre personne peut livrer l'article à votre place.

Pour cela :

• Vous devrez nous communiquer son *nom complet* avant l'expiration du délai, par WhatsApp ou par SMS.

• Cette confirmation devra obligatoirement être effectuée à partir du *numéro WhatsApp renseigné sur l'article*.

• La personne mandatée devra se présenter au point relais avant l'expiration du délai et être munie d'une *pièce d'identité*.

Passé ce délai, la commande pourra être annulée faute de livraison.`

    return `https://wa.me/${numero}?text=${encodeURIComponent(message)}`
}
